module.exports = __webpack_public_path__ + "img/atv-ride_en.84b5a25e.jpg";